import { applyPendingUpdate } from "../serviceWorkerRegistration";

const REFRESH_PARAM = "_appRefresh";

export async function clearClientCaches() {
  if (!("caches" in window)) return;
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  } catch (error) {
    console.warn("[AppUpdate] Failed to clear client caches:", error);
  }
}

export async function postMessageToServiceWorker(message) {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const target = reg?.waiting || reg?.active;
    target?.postMessage(message);
  } catch (error) {
    console.warn("[AppUpdate] Failed to postMessage to SW:", error);
  }
}

export function hardReload(targetBuildId) {
  const url = new URL(window.location.href);
  url.searchParams.set(REFRESH_PARAM, Date.now().toString());
  if (targetBuildId) {
    url.searchParams.set("_build", targetBuildId);
  }
  window.location.replace(url.toString());
}

/**
 * PWA-safe update apply: activate waiting SW, purge caches, then hard-reload.
 */
export async function forceApplyAppUpdate({ registration, targetBuildId } = {}) {
  await postMessageToServiceWorker({ type: "CLEAR_CACHES" });

  try {
    const reg =
      registration ||
      (await navigator.serviceWorker?.getRegistration());
    if (reg?.waiting) {
      await applyPendingUpdate(reg);
      return;
    }
  } catch (error) {
    console.warn("[AppUpdate] SW activation failed, falling back to cache purge:", error);
  }

  await clearClientCaches();
  hardReload(targetBuildId);
}

export function stripRefreshParams() {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has(REFRESH_PARAM) && !url.searchParams.has("_build")) return;
  url.searchParams.delete(REFRESH_PARAM);
  url.searchParams.delete("_build");
  window.history.replaceState({}, "", url.pathname + url.search + url.hash);
}
